import { cn } from '../../../lib/utils';
import { formatEnumLabel } from './adminCreditAdapters';
import {
    ADMIN_BADGE_BASE_CLASS,
    ADMIN_BADGE_NEUTRAL_CLASS,
    ADMIN_BADGE_POSITIVE_CLASS,
} from './adminStatusBadge';

function agreementStatusBadgeClass(status: string): string {
    switch (status) {
        case 'active':
            return ADMIN_BADGE_POSITIVE_CLASS;
        case 'draft':
            return ADMIN_BADGE_NEUTRAL_CLASS;
        case 'depleted':
            return 'bg-amber-50 text-amber-900 ring-1 ring-inset ring-amber-600/20';
        case 'expired':
            return 'bg-orange-50 text-orange-900 ring-1 ring-inset ring-orange-600/20';
        case 'rolled_over':
            return 'bg-sky-50 text-sky-900 ring-1 ring-inset ring-sky-600/20';
        case 'archived':
            return 'bg-slate-100 text-slate-700 ring-1 ring-inset ring-slate-300';
        default:
            return 'bg-neutral-50 text-neutral-800 ring-1 ring-inset ring-neutral-200';
    }
}

export function AgreementStatusBadge({
    className,
    status,
}: {
    status: string;
    className?: string;
}) {
    const label = formatEnumLabel(status);
    return (
        <span className={cn(ADMIN_BADGE_BASE_CLASS, agreementStatusBadgeClass(status), className)}>
            {label}
        </span>
    );
}
